module.exports = __webpack_public_path__ + "static/media/12.9cc1f3ae.jpg";